import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectFilterV2Component} from "src/app/components/common/select-filter-v2/select-filter-v2.component";
import {PaymentCardReaderSummaryFindAllService} from "../../service/paymentCardReaderSummaryFindAll.service";
import {Order, Sort, UrlParameter} from "src/app/shared/utils/url.builder";
import {SelectElementV2} from "src/app/components/common/select/selectElementV2";
import {PaymentCardReaderSummaryModel} from "../../entity/paymentCardReaderSummary.model";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-payment-card-reader-select-filter',
  standalone: true,
  imports: [CommonModule, SelectFilterV2Component],
  templateUrl: './payment-card-reader-select-filter.component.html',
  providers: [
      PaymentCardReaderSummaryFindAllService
  ]
})
export class PaymentCardReaderSelectFilterComponent implements OnChanges, OnInit {

  @Input() parentFormGroup: FormGroup;
  @Input() parentFormControlName: string;
  @Input() loading = false;

  @Output() singleSelectionChangeEvent = new EventEmitter<PaymentCardReaderSummaryModel>();

  @Input() elements: SelectElementV2<PaymentCardReaderSummaryModel>[] = [];

  constructor(public findAllService: PaymentCardReaderSummaryFindAllService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }
}
